import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}
// 获取转账记录
export function getPageTransfer (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/queryPageTransfer',
		method: 'post',
		data: obj
	})
}

// 组织批量修改账户最低余额限制
export function plEditbatchOrgAccBalanceLimit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/accBalanceLimit/batch/org',
		method: 'post',
		data: obj
	})
}
// 人员批量修改账户最低余额限制
export function plEditbatchPerAccBalanceLimit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/accInfo/accBalanceLimit/batch/per',
		method: 'post',
		data: obj
	})
}
// 组织批量最低余额限制
export function newPlEditbatchPerAccBalanceLimit (data) {
	return request({
		url: '/accInfo/accBalanceLimit/batch/orgpsn',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 人员批量红包充值
export function addRedPacketByPerson (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/red/batchPerRecharge',
		method: 'post',
		data: obj
	})
}
// 组织批量红包充值
export function addRedPacketByOrg (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/recharge/red/batchOrgRecharge',
		method: 'post',
		data: obj
	})
}
// 批量充值提示
export function orgOperateTip (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/custInfo/org/count',
		method: 'post',
		data: obj
	})
}
// 删除或停用补贴定时规则
export function deleteButieRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2.1/sub/time/delete',
		method: 'post',
		data: obj
	})
}
// 清空补贴余额

export function clearButie (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/subsidy/clear',
		method: 'post',
		data: obj
	})
}
// 确认导入补贴
export function exportButie (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/subsidy/import',
		method: 'post',
		data: obj
	})
}
// 导入补贴校验
export function exportButiejiaoyan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/subsidy/check',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 导入现金校验
export function exportXianjinjiaoyan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/wallet/import/check',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 确认导入现金
export function exportXianjin (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/wallet/import',
		method: 'post',
		data: obj
	})
}
// 老系统导入校验
export const exportOldSystem = data => {
	return request({
		url: '/api/v3/accInfo/old-system/import/check',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 老系统确认导入
export const exportOldSystemConfirm = data => {
	return request({
		url: '/api/v3/accInfo/old-system/import',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 查询老系统导入结果
export const exportOldSystemResult = () => {
	return request({
		url: '/api/v3/accInfo/old-system/import/result',
		params: dataObj,
		noLoading: true
	})
}
// 根据人员类别和人员组织查询
export function getPersonInfoData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2.0/acc/info/list',
		method: 'post',
		data: obj
	})
}

// 获取账户操作记录
export const getOperateRecords = data => {
	return request({
		url: '/api/v1/acc/operation/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴导入轮询结果查询-轮询
export const getButieImportResult = () => {
	return request({
		url: '/api/v2/subsidy/import/result',
		params: dataObj,
		noLoading: true
	})
}
// 个人钱包导入轮询结果查询-轮询
export const getWalletImportResult = () => {
	return request({
		url: '/api/v2/wallet/import/result',
		params: dataObj,
		noLoading: true
	})
}
// 冻结/解冻账户钱包
export const getFreezeAccount = data => {
	return request({
		url: '/api/v1/acc/frozen/list',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const addFreezeAccount = data => {
	return request({
		url: '/api/v1/acc/frozen/cold',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取冻结人员列表
export const getFreezedMembers = data => {
	return request({
		url: '/api/v1/acc/frozen/cust/list',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const addUnfreezeAccount = data => {
	return request({
		url: '/api/v1/acc/frozen/undo',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 转账
export const transferAccount = data => {
	return request({
		url: '/accInfo/batchTransfer',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 分页查询取款申请记录
export const getAccDrawaudit = data => {
	return request({
		url: '/api/v1/acc/drawAudit/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
		// mock: true
	})
}
// 审批同意
export const getAgreeDrawaudit = data => {
	return request({
		url: '/api/v1/acc/drawAudit/agree',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
		// mock: true
	})
}
// 审批拒绝
export const getRefuseDrawaudit = data => {
	return request({
		url: '/api/v1/acc/drawAudit/refuse',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
		// mock: true
	})
}
// 取款申请记录导出
export const exportDrawAudit = data => {
	return request({
		url: '/api/v1/acc/drawAudit/export/excel',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 新增定时冻结规则
export const addFreezeRule = data => {
	return request({
		url: '/api/v1/time/acc/frozen/rule/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取定时冻结规则
export const getFreezeRule = data => {
	return request({
		url: '/api/v1/time/acc/frozen/rule/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改定时冻结规则
export const editFreezeRule = data => {
	return request({
		url: '/api/v1/time/acc/frozen/rule/update/info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 状态变更 定时冻结规则
export const changeFreezeRule = data => {
	return request({
		url: '/api/v1/time/acc/frozen/rule/update/state',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量删除冻结规则
export const delFreezeRule = data => {
	return request({
		url: '/api/v1/time/acc/frozen/batch/delete',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 单个人解冻
export const accUnfrozen = data => {
	return request({
		url: '/api/v1/acc/frozen/single/unfrozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 单个人冻结
export const accFrozen = data => {
	return request({
		url: '/api/v1/acc/frozen/single/frozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量冻结余额接口
export const accsFrozen = data => {
	return request({
		url: '/api/v1/acc/frozen/batch/frozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量解冻余额接口
export const accsUnfrozen = data => {
	return request({
		url: '/api/v1/acc/frozen/batch/unfrozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询已冻结的人员数据接口
export const getFrozenList = data => {
	return request({
		url: '/api/v1/acc/frozen/cust/list',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 消费规则计算
export const ruleCalculation = data => {
	return request({
		url: '/api/v1/mkttimequota/rule',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
